import { CCol, CRow } from '@coreui/react'
import React from 'react'

export default function RowCount({ displayFromCount, displayToCount, totalRecords }) {
    return (
        <CRow>
            <CCol md="4">
                <div>
                    Showing {displayFromCount} to {displayToCount} of{" "}
                    {totalRecords} records
                </div>
            </CCol>
            <CCol md="4">
                {/*  */}
            </CCol>
        </CRow>
    )
}
